export default "<p>adminevent-manager-events works!</p>\n"